import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import axios from "axios";
import apiUrl from "../../config/config";
import "./topnav.css";
import { Toaster, toast } from "react-hot-toast";
class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profileLink: "/dist/img/user1.png",
      notifications: [],
      notificationCount: 0,
      showModal: false, // State to control modal visibility
    };
    this.modalRef = React.createRef(); // Create a ref for the modal content
    this.markAsRead = this.markAsRead.bind(this);
    this.handleNotificationClick = this.handleNotificationClick.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    if (this.props.auth.user.profileImage) {
      this.setState({
        profileLink:
          "https://web.mybiocalculus.com/assets/profile_image/users/" +
          this.props.auth.user.profileImage,
      });
    }

    // Function to fetch notifications
    const fetchNotifications = () => {
      axios
        .get("https://web.mybiocalculus.com:3002/api/common/getMessages")
        .then((res) => {
          this.setState({
            notifications: res.data,
            notificationCount: res.data.length,
          });

          // Ensure toast notifications are shown only here
          res.data.forEach((notification) => {
            if (notification.viewed === 0) {
              toast.success(notification.description);
            }
          });

          if (res.data.length > 0) {
            document.getElementById(
              "notificationCountContainer"
            ).style.display = "block";
          }
        })
        .catch((err) => {
          console.error("Error fetching notifications:", err);
        });
    };

    // Call the function initially
    fetchNotifications();

    // Set interval to call the function every 5 seconds
    this.notificationInterval = setInterval(fetchNotifications, 5000);

    document.addEventListener("mousedown", this.handleOutsideClick); // Add event listener
  }

  componentWillUnmount() {
    // Clear the interval when the component is unmounted
    clearInterval(this.notificationInterval);
    document.removeEventListener("mousedown", this.handleOutsideClick); // Remove event listener
  }

  async onLogoutClick(e) {
    e.preventDefault();

    try {
      await axios.post(
        `https://web.mybiocalculus.com:3002/api/users/updateLogoutTime`,
        {
          Verifier_id: localStorage.getItem("verifierid"),
          LoginedTime: localStorage.getItem("loginedDateTime"),
        }
      );

      await axios.post(
        `https://web.mybiocalculus.com:3002/api/users/UpdateVerifierActivity`,
        {
          Verifier_id: localStorage.getItem("verifierid"),
          LoginedTime: localStorage.getItem("loginedDateTime"),
          ActivityLevel: localStorage.getItem("activityPercentage"),
          BreaksConsumed: localStorage.getItem("breakTime"),
        }
      );

      this.props.logoutUser();
      window.location.href = "/login";
    } catch (err) {
      console.error("Error during logout:", err);
    }
  }

  markAsRead(e) {
    e.preventDefault();
    this.handleModalShow(); // Show the modal when "Read All" is clicked
  }

  handleModalShow() {
    this.setState({ showModal: true });
  }

  handleModalClose() {
    this.setState({ showModal: false });
  }

  handleOutsideClick(event) {
    if (
      this.modalRef.current &&
      !this.modalRef.current.contains(event.target)
    ) {
      this.setState({ showModal: false }); // Close the modal if clicked outside
    }
  }

  async handleNotificationClick(notificationId, notificationDescription) {
    toast.success(notificationDescription, {
      position: "top-center",
    });
  }

  render() {
    const { notifications, showModal } = this.state;

    let notificationList =
      notifications.length > 0 &&
      notifications.map((notification) => (
        <React.Fragment key={notification._id}>
          <div
            className="sl-item"
            onClick={() =>
              this.handleNotificationClick(
                notification._id,
                notification.description
              )
            } // Logs the ID
          >
            <a href="#">
              <div className="sl-content">
                <span className="inline-block capitalize-font pull-left truncate head-notifications">
                  🔔 {notification.description}
                </span>
                <div className="clearfix"></div>
              </div>
            </a>
          </div>
          <hr className="light-grey-hr ma-0" />
        </React.Fragment>
      ));

    return (
      <>
        <nav className="navbar navbar-inverse navbar-fixed-top">
          {/* Add the Toaster component */}
          <Toaster position="top-center" />
          <div className="mobile-only-brand pull-left">
            <div className="nav-header pull-left">
              <div className="logo-wrap">
                <a href="#">
                  <img
                    className="brand-img"
                    id="login_logo"
                    src="/dist/img/logo.png"
                    alt="brand"
                  />
                  <span className="brand-text">Biocalculus</span>
                </a>
              </div>
            </div>
            {localStorage.getItem("verifiertype") != "7" && (
              <a
                id="toggle_nav_btn"
                className="toggle-left-nav-btn inline-block ml-20 pull-left"
                href="#"
              >
                <i className="zmdi zmdi-menu"></i>
              </a>
            )}
          </div>
          <div id="mobile_only_nav" className="mobile-only-nav pull-right">
            <ul className="nav navbar-right top-nav pull-right">
              <li className="dropdown alert-drp">
                <a
                  href="#"
                  className="dropdown-toggle"
                  data-toggle="dropdown" // Ensures dropdown is triggered on click
                  aria-expanded="false" // Optional: Ensures proper accessibility
                >
                  <i className="zmdi zmdi-notifications top-nav-icon"></i>
                  <span
                    id="notificationCountContainer"
                    className="top-nav-icon-badge displayNone"
                  >
                    {this.state.notificationCount}
                  </span>
                </a>
                <ul
                  className="dropdown-menu alert-dropdown"
                  data-dropdown-in="bounceIn"
                  data-dropdown-out="bounceOut"
                >
                  <li>
                    <div className="notification-box-head-wrap">
                      <span className="notification-box-head pull-left inline-block">
                        Notifications
                      </span>
                      <a
                        className="txt-danger pull-right clear-notifications inline-block- displayNone"
                        href="#"
                      >
                        Clear All
                      </a>
                      <div className="clearfix"></div>
                      <hr className="light-grey-hr ma-0" />
                    </div>
                  </li>
                  <li>
                    <div className="streamline message-nicescroll-bar">
                      {notificationList}
                    </div>
                  </li>
                  <li>
                    <div className="notification-box-bottom-wrap">
                      <hr className="light-grey-hr ma-0" />
                      <a
                        className="block text-center read-all"
                        onClick={this.markAsRead}
                        href="#"
                      >
                        Read All
                      </a>
                      <div className="clearfix"></div>
                    </div>
                  </li>
                </ul>
              </li>
              <li className="dropdown auth-drp">
                <a
                  href="#"
                  className="dropdown-toggle pr-0"
                  data-toggle="dropdown"
                >
                  <img
                    src={this.state.profileLink}
                    alt="user_auth"
                    className="user-auth-img img-circle"
                  />
                  <span className="user-online-status"></span>
                </a>
                <ul
                  className="dropdown-menu user-auth-dropdown"
                  data-dropdown-in="flipInX"
                  data-dropdown-out="flipOutX"
                >
                  <li>
                    <a href={this.props.profileLink}>
                      <i className="zmdi zmdi-account"></i>
                      <span>Profile</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={this.onLogoutClick.bind(this)}>
                      <i className="zmdi zmdi-power"></i>
                      <span>Log Out</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        {/* Custom Modal for displaying notifications */}
        {showModal && (
          <div className="topnav-modal">
            <div className="topnav-modal-content" ref={this.modalRef}>
              <span
                className="topnav-modal-close"
                onClick={this.handleModalClose}
              >
                &times;
              </span>
              <h2>All Notifications</h2>
              <div className="topnav-table-container">
                <table className="topnav-table">
                  <thead>
                    <tr>
                      <th>Date & Time</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notifications.map((notification) => {
                      const createdAt = new Date(notification.created_at);
                      return (
                        <tr key={notification._id}>
                          <td>
                            {createdAt.toLocaleDateString()}{" "}
                            {createdAt.toLocaleTimeString()}
                          </td>
                          <td>{notification.description}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

TopNav.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(TopNav);
